function IsHybridApp() {
    return $('#app-data').length > 0;
}

export default IsHybridApp;
